export const APP = {
  name: 'Нотный сад',
  tagline: 'Услышь, увидь, сыграй и запомни',
  // Official Rodgers & Hammerstein page: watch/listen is served by the rightsholder.
  officialSongUrl: 'https://rodgersandhammerstein.com/song/the-sound-of-music/do-re-mi/',
} as const
